import React from "react";
import { Helmet } from "react-helmet";

const LogitHelmet = (props) => {
    return (
        <Helmet>
            <title>{props.pageName} | Logit Now</title>
        </Helmet>
    );
};

export default LogitHelmet;
